import {useEffect, useState} from "react";
// import InfiniteScroll from "react-infinite-scroll-component";
 //import Spinner from './../newsmonkey/Spinner';

function BreakDown () {
    const [state,setState]=useState([]);
    const [page,setPage]=useState(1);

    useEffect(()=>{
        fetch(`http://localhost:8090/api/paginatedorder?page=${page}&limit=9`)
            .then((response) => response.json())
            .then(data => setState(state=>[...state,...data]));
    },[page])
    window.onscroll = function (){
        if(window.innerHeight+document.documentElement.scrollTop === document.documentElement.offsetHeight)
        {
            ScrollToEnd();
        }
    }
    const ScrollToEnd = () => {
        setPage(page+1);
    }
  return (
    <div className="container py-4">
        {/* {state.length > 0 && state.map((el,i)=> */}
        <div className="row">
            {state.length > 0 && state.map((el,i)=>
            <div key={i} className="col-md-4 my-3">
                <div className="card">
                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        position: 'absolute',
                        right: '0'
                    }
                    }> 
                        <span className="badge rounded-pill bg-danger"> {el.RowNum} </span>
                    </div>
                    <div className="card-body">
                        <h5 className="card-title">{el.FAULT_CODE}</h5>
                        <p className="card-text">Job No: {el.JOB_NO}</p>
                        <p className="card-text">Total Count: {el.TotalCount}</p>
                        <p className="card-text">Machine Code: {el.Machine_Code}</p>
                        <p className="card-text">Workshop No: {el.Workshop_No}</p>
                        <p className="card-text">OC Date: {el.OC_DATE}</p>
                        <p className="card-text">OKAYED Date: {el.OKAYED_DATE}</p>
                    </div>
                </div>
            </div>
            )}
        </div>
    </div>
  );
	}

export default BreakDown;